import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { selectUserAdminBusinessIds } from 'scenes/Permissions/store/selectors/base-project-permissions.selectors';
import { generateReportFromRecords } from 'scenes/WorkDemo/utils/report-generation/generateReportFromRecords';
import { selectAssignmentsArray } from 'store/assignments/selectors/assignment.selectors';
import { selectProjectUsersArray } from 'store/projectUsers/selectors/projectUsers.selectors';
import { loadEmployeeConfigurationsInBusiness } from 'store/projectUsers/thunks/loadEmployeeConfigurationsInBusiness.thunk';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectRecordAllowancesGroupedByRecordId } from 'store/recordAllowances/selectors/record-and-employer-allowances.selectors';
import { selectSelectedRecordsIds } from 'store/records/selectors/records-base.selectors';
import { selectWorkCalendarAllowanceTypeRecordsGroupedByParentRecordId } from 'store/records/selectors/records.selectors';
import {
  selectIsRecordBasedReductionsActive,
  selectIsReportProjectHourRowsEnabled,
  selectReportGeneratedFromMode,
} from 'store/reports/selectors/reports.selectors';
import {
  selectProjectsDataResourcesArrayWithEmployeeConfigurationInformation,
  selectWorkCalendarFilteredRecords,
  selectWorkCalendarProjectsArray,
} from '../../selectors/workSelectorsDemo';

export const generateSalaryRowDataFromRecords = createAsyncThunk(
  'workCalendar/generateSalaryRowDataFromRecords',
  async (dialogSettings, { getState, dispatch }) => {
    const selectedProject = selectSelectedProject(getState());

    const selectedRecordIds = selectSelectedRecordsIds(getState());

    const reportGeneratedFromMode = selectReportGeneratedFromMode(getState());

    const projects = selectWorkCalendarProjectsArray(getState());

    const allWorkCalendarFilteredRecords = selectWorkCalendarFilteredRecords(
      getState()
    );

    const assignments = selectAssignmentsArray(getState());

    const users = selectProjectUsersArray(getState());

    const isRecordBasedReductions = selectIsRecordBasedReductionsActive(
      getState()
    );

    const isReportProjectHourRowsEnabled = selectIsReportProjectHourRowsEnabled(
      getState()
    );

    const userAdminBusinessIds = selectUserAdminBusinessIds(getState());

    const recordAllowancesGroupedByRecordId =
      selectRecordAllowancesGroupedByRecordId(getState());

    const allowanceRecordsGroupedByParentRecordId =
      selectWorkCalendarAllowanceTypeRecordsGroupedByParentRecordId(getState());

    const recordsToGenerateReportFrom =
      reportGeneratedFromMode === 'SELECTED'
        ? allWorkCalendarFilteredRecords.filter((record) =>
            selectedRecordIds.includes(record.id)
          )
        : allWorkCalendarFilteredRecords;

    const utcOffset = moment.parseZone(moment().format()).format('Z');

    const {
      selectedReportType,
      workStartTime,
      workEndTime,
      fromDate,
      toDate,
      language,
      filetype,
      workHourType,
      paidCoffeeBreakMinutes,
    } = dialogSettings;

    const generationParams = {
      fromDate: moment(fromDate).utcOffset(0, true).format(),
      toDate: moment(toDate).utcOffset(0).format(),
      selectedReportType,
      workStartTime,
      workEndTime,
      language,
      filetype,
      utcOffset,
      workHourType,
      isRecordBasedReductions,
      paidCoffeeBreakMinutes,
      isProjectHourRowsEnabled: isReportProjectHourRowsEnabled,
    };

    if (userAdminBusinessIds && userAdminBusinessIds.length > 0) {
      await dispatch(loadEmployeeConfigurationsInBusiness());
    }

    const resources =
      selectProjectsDataResourcesArrayWithEmployeeConfigurationInformation(
        getState()
      );

    const report = await generateReportFromRecords(
      recordsToGenerateReportFrom,
      resources,
      assignments,
      users,
      generationParams,
      projects,
      selectedProject,
      recordAllowancesGroupedByRecordId,
      allowanceRecordsGroupedByParentRecordId
    );

    return report;
  }
);
